export default "__VITE_ASSET__DvEhf3AD__"